import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as CustomerFeedbackMdls from '../../models/CustomerFeedbackModel';
import * as CustomerFeedbackStore from '../../store/CustomerFeedbackList';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect } from 'react';

type MyProps =
    { CustomerFeedback: CustomerFeedbackMdls.CustomerFeedbackListModel, SessionState: SessionModel } & typeof CustomerFeedbackStore.actionCreators;


const CustomerFeedbackList: React.FunctionComponent<MyProps> = (props: MyProps) => {
   
    useEffect(() => {
        props.loadFeedbacks();
    }, []);

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.CustomerFeedback.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Row>
                <Col className='center-align' xs={12}>
                    <Link to={{ pathname: "/FeedbackEntry" }}><Button className='top-screen-button'>New Feedback</Button></Link>
                </Col>
            </Row>
            {props.CustomerFeedback.items.map((item, index) =>
                <Row key={index} >
                    <Col xs={12}>
                        <CustomerFeedbackListCard item={item}> </CustomerFeedbackListCard>
                    </Col>
                </Row>
            )}           
        </Container>
    );
}

const CustomerFeedbackListCard: React.FunctionComponent<{ item: CustomerFeedbackMdls.CustomerFeedbackModel }> = (props: { item: CustomerFeedbackMdls.CustomerFeedbackModel }) => {

    const FeedbackResponse = () => {
        return (<div className="customerFeedback-response-card">
            <Row>
                <Col xs="12">
                    <span className='text-bold'>
                        Response from {props.item.responseGivenBy}
                    </span>
                    <span style={{ marginLeft: "3px"}}> {props.item.responseGivenOn}</span>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    {props.item.responseMessage}
                </Col>
            </Row></div>);
    };

    return (<Card className='customerFeedback-card'>
        <CardBody>
            <Row>
                <Col xs="12" className='text-bold'>
                    {props.item.contactPerson} 
                </Col>                    
            </Row>    
            <Row>
                <Col sm="6">
                    {props.item.contactPersonPhone}
                </Col>            
                <Col sm="6">                    
                    Invoice {props.item.invoiceNum}
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    {props.item.customerComments}
                </Col>
            </Row>
            {props.item.responseGiven&&<FeedbackResponse/>}
        </CardBody>
    </Card>);
}

export default connect(
    (state: ApplicationState) => ({ CustomerFeedback: state.customerFeedbackListState, SessionState: state.sessionState }),
    CustomerFeedbackStore.actionCreators)(CustomerFeedbackList as any);
